import React, { useState } from "react";
import { Grid, Box, Typography, Chip, CardActionArea } from "@mui/material";
import { TaskAlt, DoNotDisturb } from "@mui/icons-material";
import SdvUploadDialog from "./SdvUploadDialog";
import { useQuery } from "react-query";
import { getSdvFeatureDataCount } from "../../services/SdvFeature";

const SdvFeatureStats = () => {
  const [openModal, setOpenModal] = useState(false);

  const {
    data: {
      data: {
        sdvFeatureCount = 0,
        activeCount = 0,
        inactiveCount = 0,
      } = {},
    } = {},
  } = useQuery("getSdvFeatureDataCount", getSdvFeatureDataCount, {
    refetchOnWindowFocus: false,
  });

  const onClose = () => setOpenModal(false);

  return (
    <>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
        <Box
          sx={{
            height: "100%",
            border: "0.5px solid",
            borderColor: "divider",
            borderRadius: 3,
            p: "24px 28px",
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <Typography
            variant="overline"
            sx={{
              fontSize: "11px",
              fontWeight: 500,
              letterSpacing: "0.07em",
              color: "text.disabled",
              lineHeight: 1,
            }}
          >
            Total features
          </Typography>

          <Typography
            sx={{
              fontSize: "48px",
              fontWeight: 500,
              color: "text.primary",
              lineHeight: 1,
            }}
          >
            {sdvFeatureCount || 0}
          </Typography>

          <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
            <Chip
              icon={
                <TaskAlt 
                  sx={{ fontSize: "14px !important" }}
                />
              }
              label={`${activeCount} active`}
              size="small"
              sx={{
                bgcolor: "#EAF3DE",
                color: "#27500A",
                fontWeight: 500,
                fontSize: "12px",
                "& .MuiChip-icon": { color: "#27500A" },
              }}
            />
            <Chip
              icon={
                <DoNotDisturb 
                  sx={{ fontSize: "14px !important" }}
                />
              }
              label={`${inactiveCount} inactive`}
              size="small"
              sx={{
                bgcolor: "#F1EFE8",
                color: "#5F5E5A",
                fontWeight: 500,
                fontSize: "12px",
                "& .MuiChip-icon": { color: "#5F5E5A" },
              }}
            />
          </Box>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
        <CardActionArea
          onClick={() => setOpenModal(true)}
          sx={{ borderRadius: 3, height: "100%" }}
        >
          <Box
            sx={{
              height: "100%",
              minHeight: 140,
              border: "1.5px dashed",
              borderColor: "divider",
              borderRadius: 3,
              p: "24px 28px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "14px",
              transition: "border-color 0.15s, background 0.15s",
              "&:hover": {
                borderColor: "text.secondary",
                bgcolor: "action.hover",
              },
            }}
          >
            <Box sx={{ position: "relative", width: 64, height: 40 }}>
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  bgcolor: "action.hover",
                  border: "0.5px solid",
                  borderColor: "divider",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 8,
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  bgcolor: "action.hover",
                  border: "0.5px solid",
                  borderColor: "divider",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 8,
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  bgcolor: "action.hover",
                  border: "0.5px solid",
                  borderColor: "divider",
                }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                letterSpacing: "0.07em",
                textTransform: "uppercase",
                color: "text.secondary",
              }}
            >
              Create feature
            </Typography>

            <Typography
              sx={{
                fontSize: "12px",
                color: "text.disabled",
              }}
            >
              Upload or configure a new SDV feature
            </Typography>
          </Box>
        </CardActionArea>
      </Grid>

      <SdvUploadDialog
        openModal={openModal}
        onClose={onClose}
        setOpenModal={setOpenModal}
      />
    </>
  );
};

export default SdvFeatureStats;